import { render, staticRenderFns } from "./BlogSidebar.component.vue?vue&type=template&id=70e647de&"
import script from "./BlogSidebar.component.vue?vue&type=script&lang=js&"
export * from "./BlogSidebar.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports